/**
 * How the book splits by type, plan, source and owner — the top six of each.
 *
 * Four panels, two to a row. Each carries its own icon and colour so a glance
 * tells you which split you are reading, and each bar shows the share of the
 * book as well as the count: "549" alone does not say whether that is most of
 * the list or a corner of it.
 */
import { useApp } from '../store/AppContext.jsx';
import Icon from '../lib/icons.jsx';
import { Card, CardHead } from './Primitives.jsx';

const GROUPS = [
  ['Account type', 'acctType', 'star', 'g-purple'],
  ['Plan', 'plan', 'tag', 'g-green'],
  ['Source', 'source', 'zap', 'g-amber'],
  ['Owner', 'handler', 'users', 'g-blue']
];

export default function BreakdownCard() {
  const { rows, derive } = useApp();

  return (
    <Card>
      <CardHead icon="chart" tone="g-cyan" title="Breakdown" />

      <div className="bdgrid">
        {GROUPS.map(([title, key, icon, tone]) => {
          const counts = {};
          rows.forEach(r => {
            const v = key === 'acctType' ? derive(r).type : (String(r[key] || '').trim() || 'Unassigned');
            counts[v] = (counts[v] || 0) + 1;
          });

          const all = Object.entries(counts).sort((a, b) => b[1] - a[1]);
          const entries = all.slice(0, 10);
          const total = all.reduce((t, x) => t + x[1], 0) || 1;
          const max = Math.max(1, ...entries.map(x => x[1]));

          return (
            <section className="bdpanel" data-tone={tone} key={key}>
              <h4>
                <span className={`ic ${tone}`}><Icon name={icon} /></span>
                {title}
                <b>{all.length}</b>
              </h4>

              <div className="bdbody">
                {entries.map(([name, value], i) => (
                  /* The leader carries the emphasis; the rest read as context. */
                  <div className={`bdrow${i === 0 ? ' lead' : ''}`} key={name}>
                    <span className="bdrank">{i + 1}</span>
                    <span className="bdlab" title={name}>{name}</span>
                    <span className="bdnum">
                      {value}
                      <i>{Math.round(value / total * 100)}%</i>
                    </span>
                    <span className="bdtrack">
                      <i style={{ width: `${Math.max(2, value / max * 100)}%` }} />
                    </span>
                  </div>
                ))}

                {all.length > entries.length ? (
                  <div className="bdmore">
                    +{all.length - entries.length} more
                  </div>
                ) : null}
              </div>
            </section>
          );
        })}
      </div>
    </Card>
  );
}
